export default __webpack_public_path__ + "static/media/image@3x.e0b653a1.jpg";